import * as signalR from '@microsoft/signalr';

export default class SignalRClient {
  /**
   * @param {string} baseUrl - URL base del servidor, por ejemplo: "http://localhost:3000"
   * @param {string} relativePath - Ruta relativa del hub, por ejemplo: "/chathub"
   * @param {object} options - Opciones adicionales (por ejemplo, token de autenticación).
   */
  constructor(baseUrl, relativePath, options = {}) {
    this.baseUrl = baseUrl;
    this.relativePath = relativePath;
    // Se construye la URL completa del hub eliminando barras adicionales
    this.hubUrl = `${this.baseUrl.replace(/\/+$/, '')}/${this.relativePath.replace(/^\/+/, '')}`;
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(this.hubUrl, options)
      .configureLogging(signalR.LogLevel.Information)
      .build();
  }

  /**
   * Inicia la conexión al hub SignalR.
   */
  async start() {
    try {
      await this.connection.start();
      console.log("Conexión SignalR establecida.");
    } catch (error) {
      console.error("Error al iniciar la conexión SignalR:", error);
      // Reintentar la conexión después de 5 segundos en caso de fallo
      setTimeout(() => this.start(), 5000);
    }
  }

  /**
   * Registra un manejador para un evento recibido desde el servidor.
   * @param {string} eventName - Nombre del evento.
   * @param {function} handler - Función que se ejecutará al recibir el evento.
   */
  on(eventName, handler) {
    this.connection.on(eventName, handler);
  }

  /**
   * Elimina un manejador de evento.
   * @param {string} eventName - Nombre del evento.
   * @param {function} handler - Función a eliminar.
   */
  off(eventName, handler) {
    this.connection.off(eventName, handler);
  }

  /**
   * Invoca un método en el servidor.
   * @param {string} methodName - Nombre del método en el servidor.
   * @param  {...any} args - Argumentos a enviar.
   */
  async send(methodName, ...args) {
    try {
      return await this.connection.invoke(methodName, ...args);
    } catch (error) {
      console.error(`Error al enviar el método ${methodName}:`, error);
    }
  }

  /**
   * Cierra la conexión al hub SignalR.
   */
  async stop() {
    try {
      await this.connection.stop();
      console.log("Conexión SignalR cerrada.");
    } catch (error) {
      console.error("Error al detener la conexión SignalR:", error);
    }
  }
}